import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import i18n from './i18n'

import { VueReCaptcha } from 'vue-recaptcha-v3'

const recaptchaKey = '6LdnnXIrAAAAAFThBgrIHGkSlKZcaGquMCl_bI0f'

loadFonts()

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.use(i18n)
app.use(VueReCaptcha, {
  siteKey: recaptchaKey,
  loaderOptions: {
    autoHideBadge: false,
    badge: 'bottomright',
  },
})

app.mount('#app')
